var parseuri = require('./parseuri');
module.exports = function(location, referrer, serviceProviders) {
    if (referrer && referrer.length > 0) {
        var referrerAuth = parseuri(referrer).authority;
        var currentAuth = parseuri(location).authority;
        if (referrerAuth != currentAuth && serviceProviders.indexOf(referrerAuth) === -1) {
            return referrer;
        }
    }
    return null;
}




//////////////////
// WEBPACK FOOTER
// ./src/referrer.js
// module id = 32
// module chunks = 0 1 2